import type { VoidComponent } from "solid-js";
import { Show } from "solid-js";
import FormVersionPreview from "../preview/FormVersionPreview.tsx";
import { useTranslation } from "../../../state/i18n.tsx";
import type { FormVersion } from "../../../state/formVersion.tsx";
import type { Form } from "../../../state/form.tsx";

type VersionHistoryPreviewProps = {
  form: Form;
  formVersion: FormVersion | null;
};

const VersionHistoryPreview: VoidComponent<VersionHistoryPreviewProps> = (props) => {
  const { t } = useTranslation();

  return (
    <div class="grow">
      <Show when={props.formVersion}>
        {(formVersion) => (
          <FormVersionPreview
            title={t(($) => $.VERSION_HISTORY_PREVIEW_TITLE)}
            form={props.form}
            formVersion={formVersion()}
          />
        )}
      </Show>
    </div>
  );
};

export default VersionHistoryPreview;
